import { RefundBadgeIcon } from "@assets/icons";

export function AssuranceBadge() {
  const badges = Array.from({ length: 10 });

  const renderBadges = () =>
    badges.map((_, i) => (
      <span key={i} className="mx-4">
        <RefundBadgeIcon />
      </span>
    ));

  return (
    <div className="flex overflow-hidden bg-primary-light py-4">
      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap">
          {renderBadges()}
        </div>

        <div className="absolute top-0 flex animate-marquee2 whitespace-nowrap">
          {renderBadges()}
        </div>
      </div>
    </div>
  );
}
